import DateRangePicker from './DateRangePicker.vue'

export default DateRangePicker
